import React, { Fragment, useMemo } from "react";
import { message, Modal } from "antd";
import "./role-add-account-modal.less";
import { lib } from "../../index";

export default function RoleAccountCancelPermissionModal({ roleId, roleName, cancelRow = [], onClose, visible }) {
    function okHandle() {
        const userIdList = cancelRow.reduce((pre, cur) => [...pre, cur.id], []);
        lib.request({
            url:
                lib.config.webToken === "admin"
                    ? "/ucenter-admin/role/unbind/user"
                    : "/ucenter-customer/role/unbind/user",
            data: { roleId, userIdList },
            needMask: true,
            success: res => {
                onClose(true);
                message.warn("取消权限成功！");
            },
        });
    }

    function onCancelHandle() {
        onClose(false);
    }

    const displayNameArr = useMemo(
        () =>
            cancelRow.map((item, index) => {
                return (
                    <span key={index}>
                        <span className={"link cursor-auto"}>{item.userName}</span>
                        {index < cancelRow.length - 1 ? "、" : ""}
                    </span>
                );
            }),
        [cancelRow],
    );

    return (
        <Modal
            title={"取消权限"}
            open={visible}
            maskClosable={false}
            destroyOnClose={true}
            onOk={() => okHandle()}
            onCancel={() => onCancelHandle()}>
            <div>
                是否确认取消用户{displayNameArr}的<span className={"link cursor-auto"}>{roleName}</span>权限？
            </div>
        </Modal>
    );
}
